import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content" }




export default /*@__PURE__*/_defineComponent({
  __name: 'AInfoPanel',
  props: {
    icon: {},
    backgroundColor: { default: '#f5ebef' }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "panel",
    style: _normalizeStyle({ backgroundColor: props.backgroundColor })
  }, [
    (props.icon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "icon",
          style: _normalizeStyle({ backgroundImage: `url(${props.icon})` })
        }, null, 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4))
}
}

})